














































































import { Component, Vue } from 'vue-property-decorator';

// Components
import Welcome from '@/components/Global/Welcome.vue';
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';

// Services
import Staff from '@/services/Staff';
import * as Sentry from '@sentry/browser';

@Component({
	name: 'InviteList',
	components: {
		Welcome,
		Alert,
		Loading,
	},
})
export default class InviteList extends Vue {
	private loading: boolean = true;
	private error: boolean = false;
	private errorDelete: boolean = false;
	private successDelete: boolean = false;
	private invites: any[] = [];
	private paginate: string[] = ['invites'];
	private selectedInvites: string[] = [];

	private loadInvite(email) {
		this.$router.push({
			name: 'staffusermanagementinvitesingle',
			params: {
				email,
			},
		});
	}

	private async deleteInvites() {
		this.successDelete = false;
		this.errorDelete = false;

		if (!confirm('Are you sure you want to delete the invites?')) {
			return;
		}

		try {
			await Staff.deleteInvites(this.selectedInvites);
			this.successDelete = true;

			this.invites = this.invites.filter(
				invite => !this.selectedInvites.includes(invite.email),
			);

			this.selectedInvites = [];
		} catch (e) {
			console.log(e);
			this.errorDelete = true;
		}
	}

	private async created() {
		try {
			const getInvites = await Staff.getInvites();
			const data = getInvites.data;
			if ('error' in data) {
				this.error = data.error;
			} else {
				this.invites = data;
			}
		} catch (e) {
			Sentry.captureException(e);
			this.error = e;
		} finally {
			this.loading = false;
		}
	}
}
